import login from "./login";

export const api = {
  login,
};

export default (app) => {
  app.config.globalProperties.$api = api;
  app.provide("$api", api);
};
